import { useSelector } from "react-redux";
import { RaytebRequests } from "../../_services";
import useFetch from "../../_services/fetch";
import { AppointmentTicketRequestInterface } from "../../Interfaces/AppointmentCardInterface";
import {
  AppointmentTicketRequestCard,
  LoadingFit,
  PageHeader,
  SecondaryLayout,
} from "../../share/Components";
import { ReducerType } from "../../storeManager/ReducerType";
import { LoginInterface } from "../../Interfaces/LoginInterface";
import { useEffect, useRef, useState } from "react";
import {
  Button,
  CheckBox,
  DatePicker,
  Icon,
  TextBox,
  TypeaheadText,
} from "../../share/Elements";
import { useSearchParams } from "react-router-dom";
import { JitsiMeeting } from "@jitsi/react-sdk";
import HelTag from "react-helmet";
import { DoctorShiftType } from "../../share/Components/Modal/NewAppointmentModal";
import { TextBoxTypeEnum } from "../../enums/TextBoxTypeEnum";
import { ShiftEnum } from "../../enums/ShiftEnum";
import useSocket from "../../_services/socket";

type ChatSettingType = {
  users: { position: "right" | "left"; clientId: string }[];
  positionBots: "right" | "left";
};

const shiftsCollection: Array<DoctorShiftType> = [
  { key: "1", value: "صبح" },
  { key: "2", value: "ظهر" },
  { key: "3", value: "شب" },
];

const TicketRequest = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filterDate, setFilterDate] = useState<Date>(
    (searchParams.get("date") as unknown as Date) || new Date(),
  );
  const [showjitsi, setShowJitsi] = useState<boolean>(false);
  const ticketId = searchParams.get("ticketId");
  const [isPayChecked, setIsPayChecked] = useState<boolean>(!ticketId);
  const chatSetting = { positionBots: "right" } as ChatSettingType;
  const jitsiRef = useRef<HTMLDivElement>();
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser,
  );
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter,
  );
  const toggleIsEndTicketRequest = useFetch<
    unknown,
    ToggleIsEndTicketRequestInputModel
  >({
    request: RaytebRequests.Appointment_ToggleIsEndTicketRequest_POST({
      headers: { centerId: center.id },
      token: user?.token,
    }),
    onSuccess(data) {
      const arr = [...listTicketRequests];
      const index = listTicketRequests.findIndex(
        (x) => x.ticketId === currentChat?.ticketId,
      );
      if (index === -1) return;
      arr[index].isEnd = !arr[index].isEnd;
      setTicketRequests(arr);
    },
  });
  const ticketRequest = useFetch<
    Array<AppointmentTicketRequestInterface>,
    { Date: Date; IsPay: boolean }
  >({
    request: RaytebRequests.Appointment_ListTicketRequest_POST({
      headers: { centerId: center.id },
      token: user.token,
    }),
    onSuccess(data) {
      if (!data.some((x) => x.ticketId === ticketId))
        setSearchParams((x) => {
          x.set("ticketId", "");
          return x;
        });

      setTicketRequests(data);
    },
  });
  const [listTicketRequests, setTicketRequests] = useState<
    Array<AppointmentTicketRequestInterface>
  >([]);
  const currentChat = ticketRequest.result?.find(
    (x) => x.ticketId === ticketId,
  );

  const setMeetingRequest = useFetch<unknown, SetMeetingInterface>({
    request: RaytebRequests.Appointment_SetMeeting_POST({
      token: user.token!,
      headers: { centerId: center.id },
    }),
    onSuccess(data) {
      if (setMeetingRequest.payLoad?.isJoin) setShowJitsi(true);
      else setShowJitsi(false);
    },
  });

  const socket = useSocket({
    controllerName: "appointment",
    token: `${user.token!}`,
    ReciveMethods: {
      methods: [
        {
          name: "deleteAppointment",
          onRecived: (data) => {
            if (filterDate)
              ticketRequest.reFetch({ Date: filterDate, IsPay: isPayChecked });
          },
        },
        {
          name: "newAppointment",
          onRecived: (data) => {
            if (filterDate)
              ticketRequest.reFetch({ Date: filterDate, IsPay: isPayChecked });
          },
        },
      ],
      dependencies: [setMeetingRequest.payLoad],
    },
  });
  useEffect(() => {
    if (filterDate)
      ticketRequest.reFetch({ Date: filterDate, IsPay: isPayChecked });
  }, [center, filterDate, isPayChecked]);
  return (
    <>
      <HelTag>
        <title>نوبت ها</title>
      </HelTag>
      <PageHeader title="مشاوره آنلاین" path="/" />
      {showjitsi ? (
        <JitsiMeeting
          domain={"telme.rayteb.ir"}
          onReadyToClose={() => {
            setMeetingRequest.reFetch({
              patientCode: setMeetingRequest.payLoad?.patientCode!,
              ticketId: setMeetingRequest.payLoad?.ticketId!,
              isJoin: false,
            });
          }}
          roomName={setMeetingRequest.payLoad?.ticketId!}
          getIFrameRef={(x) => {
            x.style.display = "block";
            x.style.position = "fixed";
            x.style.width = "100%";
            x.style.height = "100%";
            x.style.zIndex = "999999";
            x.style.top = "0";
            x.style.left = "0";
            jitsiRef.current = x;
          }}
          configOverwrite={{
            doNotStoreRoom: false,
            enableWelcomePage: true,
            prejoinPageEnabled: false,
            remoteVideoMenu: {
              disableKick: false,
            },
          }}
          interfaceConfigOverwrite={{
            SHOW_WATERMARK_FOR_GUESTS: false,
            DEFAULT_REMOTE_DISPLAY_NAME: "New User",
            TOOLBAR_BUTTONS: [
              "hangup",
              "microphone",
              "camera",
              "tileview",
              "desktop",
              "settings",
            ],
          }}
          onApiReady={(api) => {}}
        />
      ) : (
        <></>
      )}
      <div className="h-[calc(100%_-_41px)]">
        {ticketId ? (
          <>
            <div className="w-full h-10 bg-white flex justify-center items-center relative border-b border-primary rounded-b-2xl">
              <Icon
                icon="rayteb-android-close"
                className="!w-12 !h-12  text-xl absolute right-0"
                onClick={() => {
                  setSearchParams((x) => {
                    x.set("ticketId", "");
                    return x;
                  });
                }}
              />
              <h2>
                {currentChat?.firstName} {currentChat?.lastName}
              </h2>
              {currentChat?.isEnd ? (
                <Button
                  onClick={() =>
                    toggleIsEndTicketRequest.reFetch({
                      ticketId: currentChat.ticketId!,
                    })
                  }
                  type="button"
                  className={`!bg-secondaryLight/40 text-secondaryDark !border-dangerDark  
                    shadow-sm !text-xs font-bold !px-2
                    col-span-2 py-1 absolute left-3`}
                >
                  بازکردن چت
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    toggleIsEndTicketRequest.reFetch({
                      ticketId: currentChat?.ticketId!,
                    });
                  }}
                  type="button"
                  className={`!bg-dangerLight/40 text-dangerDark !border-dangerDark  
                    shadow-sm !text-xs font-bold !px-2
                    col-span-2 py-1 absolute left-3`}
                >
                  بستن چت
                </Button>
              )}
            </div>
            <iframe
              src={`./Chat?${currentChat?.userChat ? `token=${currentChat?.userChat.accessToken}&clientId=${currentChat?.userChat.clientId}` : ""}&settingChat=${encodeURIComponent(JSON.stringify(chatSetting))}`}
              className="w-full min-h-[600px] h-[calc(100%_-_2.5rem)]"
            ></iframe>
          </>
        ) : (
          <div className="flex flex-col items-center justify-start gap-2 p-2 relative">
            <LoadingFit isLoading={ticketRequest.isLoading} />
            <div className="relative md:max-w-md md:mx-auto">
              <div
                className={
                  "px-4 mt-5 grid grid-cols-10 gap-3 md:gap-4 items-center justify-center content-center"
                }
              >
                <div className="col-span-7">
                  <TypeaheadText<DoctorShiftType>
                    innerText="شیفت / خدمت"
                    className="w-full h-9"
                    listData={[
                      { key: null, value: "همه" },
                      ...shiftsCollection,
                    ]}
                    fieldItem="value"
                    fieldValue="key"
                    selected={(e) => {
                      if (e.key == null)
                        setTicketRequests(ticketRequest.result ?? []);
                      else {
                        const ticketRequests = ticketRequest.result
                          ? [...ticketRequest.result].filter(
                              (x) => x.shift == parseInt(e.key!),
                            )
                          : [];
                        setTicketRequests(ticketRequests);
                      }
                    }}
                  ></TypeaheadText>
                </div>
                <div className="col-span-3">
                  <DatePicker
                    className="h-7 w-full"
                    value={new Date(filterDate).toShamsi()}
                    onChange={(e) => {
                      setSearchParams((x) => {
                        x.set(
                          "date",
                          new Date(e.target.valueMiladi).toUTCString(),
                        );
                        return x;
                      });
                      setFilterDate(e.target.valueMiladi);
                    }}
                    isRequired={true}
                    innerText="تاریخ"
                  />
                </div>
              </div>
              <div
                className={
                  "px-4 mt-5 grid grid-cols-10 gap-3 md:gap-4 items-center justify-center content-center"
                }
              >
                <div className="col-span-6">
                  <TextBox
                    debounceTime={0}
                    className="w-full h-8 "
                    innerText="جستجوی نام و نام خانوادگی ، کد ملی"
                    Type={TextBoxTypeEnum.Text}
                    onChange={(e) => {
                      const arr = e.target.value
                        .split(" ")
                        .map((n) => n.replace(" ", ""));

                      const ticketRequests = ticketRequest.result
                        ? [...ticketRequest.result].filter((x) =>
                            arr.some(
                              (s) =>
                                x.firstName?.includes(s) ||
                                x.lastName?.includes(s) ||
                                x.code?.includes(s),
                            ),
                          )
                        : [];

                      setTicketRequests(ticketRequests);
                    }}
                  />
                </div>
                <div className="col-span-4 flex justify-center items-center gap-2">
                  <CheckBox
                    className="text-xs !font-bold"
                    checked={isPayChecked}
                    lable="پرداخت"
                    onChange={() => {
                      setIsPayChecked(!isPayChecked);
                    }}
                  />
                  <CheckBox
                    onChange={(e) => {
                      if (e.target.checked) {
                        const ticketRequests = ticketRequest.result
                          ? [...ticketRequest.result].filter(
                              (x) => x.isVisit === e.target.checked,
                            )
                          : [];

                        setTicketRequests(ticketRequests);
                      } else setTicketRequests(ticketRequest.result ?? []);
                    }}
                    lable="ویزیت"
                    className="text-xs !font-bold"
                  />
                </div>
              </div>
            </div>
            <div className="grid xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 w-full gap-2 mt-2">
              {listTicketRequests?.map((x, i) => (
                <AppointmentTicketRequestCard
                  onToggleIsEnd={() => {
                    const arr = [...listTicketRequests];
                    arr[i].isEnd = !arr[i].isEnd;
                    setTicketRequests(arr);
                  }}
                  key={x.ticketId}
                  {...x}
                  currentTicketId={ticketId}
                  onStartMetting={() =>
                    setMeetingRequest.reFetch({
                      patientCode: x.code!,
                      ticketId: x.ticketId!,
                      isJoin: true,
                    })
                  }
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TicketRequest;
